<template>
<v-layout>
	<Item
		:list="czNaces"
		@add="addCzNace"
		@remove="removeCzNace"
		@edit="changeCzNace"
		:label="$t('workers.cz_nace')"
	/>
</v-layout>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Item from '../Item'

export default {
	components: {
		Item
	},
	methods: {
		...mapMutations({
			addCzNace: 'settings/addCzNace',
			removeCzNace: 'settings/removeCzNace',
			changeCzNace: 'settings/changeCzNace'
		})
	},
	computed: {
		...mapState({
			czNaces: ({ settings }) => settings.settings.czNaces
		})
	}
}
</script>
